/*
  The list endpoints embed approval lines either as an array (invoices) or as a FOR JSON string (credit notes),
  and lines may come from the old shape (Goedgekeurd / GoedgekeurdDoorID) or the new one (Status / approverId).
  Returns a uniform array: { id, amount, approverId, status, costTypeId, projectId, projectNumber, note, rejectReason }.
*/
export function normalizeApprovalLines(raw) {
  let lines = raw;
  if (!lines) return [];
  if (typeof lines === 'string') {
    try {
      lines = JSON.parse(lines);
    } catch (err) {
      return [];
    }
  }
  if (!Array.isArray(lines)) return [];
  return lines.map((line) => {
    const approved = line.Goedgekeurd === true || line.Goedgekeurd === 1;
    return {
      id: line.id ?? line.ProjectFactuurInID ?? line.ApprovalID ?? null,
      amount: Number(line.Bedrag ?? line.amount) || 0,
      approverId: line.approverId ?? line.GoedgekeurdDoorID ?? line.GoedgekeurdDoorGebruikersID ?? null,
      approverAfkorting: line.approverAfkorting || null,
      status: line.Status || (approved ? 'APPROVED' : 'PENDING'),
      costTypeId: line.FactuurTypeID ?? null,
      costTypeName: line.costTypeName || null,
      projectId: line.ProjectID ?? null,
      projectNumber: line.projectNumber || null,
      projectDescription: line.projectDescription || null,
      note: line.Notitie || null,
      rejectReason: line.RejectReason || null
    };
  });
}
